import { useState, useEffect, useRef } from "react";

interface UseTimerProps {
  initialMinutes?: number;
  initialSeconds?: number;
}

interface UseTimerReturn {
  minutes: string;
  seconds: string;
  startTimer: () => void;
  stopTimer: () => void;
  resetTimer: () => void;
  isRunning: boolean;
}

export const useTimer = ({
  initialMinutes = 5,
  initialSeconds = 0,
}: UseTimerProps = {}): UseTimerReturn => {
  const [minutes, setMinutes] = useState(initialMinutes);
  const [seconds, setSeconds] = useState(initialSeconds);
  const [isRunning, setIsRunning] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        } else if (minutes > 0) {
          setMinutes(minutes - 1);
          setSeconds(59);
        } else {
          stopTimer();
        }
      }, 1000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [minutes, seconds, isRunning]);

  const startTimer = () => {
    setIsRunning(true);
  };

  const stopTimer = () => {
    setIsRunning(false);
  };

  const resetTimer = () => {
    setMinutes(initialMinutes);
    setSeconds(initialSeconds);
    setIsRunning(false);
  };

  const formatTime = (time: number): string =>
    time < 10 ? `0${time}` : `${time}`;

  return {
    minutes: formatTime(minutes),
    seconds: formatTime(seconds),
    startTimer,
    stopTimer,
    resetTimer,
    isRunning,
  };
};
